<ul class="error__list" [ngClass]="{ 'error__list--show': showErrors || showFromErrors }">
  @for (error of errors(); track $index) {
    <li
      class="card error__card"
      (mouseenter)="error.directive.onNotifierErrorMouseEnter()"
      (mouseleave)="error.directive.onNotifierErrorMouseLeave()"
      (click)="error.directive.onNotifierErrrorClick()"
    >
      <div class="card__header">
        <h6 class="error__title">
          <i class="digi-out-alert-warning"></i>
          @if (error.directive.label) {
            {{ error.directive.label }} -
          }
          @if (error.title) {
            {{ error.title | abpLocalization }}
          } @else if (error.key && !error.title) {
            {{ error.key | abpLocalization }}
          }
        </h6>
      </div>
      @if (error.notifierErrorMessage) {
        <p class="error__message">
          {{ error.notifierErrorMessage | abpLocalization: error.interpolationParams }}
        </p>
      } @else if (error.errorMessage) {
        <p class="error__message">
          {{ error.errorMessage }}
        </p>
      }
    </li>
  }
</ul>
